import { useDispatch } from "react-redux";
import { weightDifferencesActions } from "../../_store/weightDifferences.slice";
import { WeightDifferencesForm } from "../../_components/Wastes/WeightDifferencesForm";

export function UpdateWeightDifference({ item }) {
  const dispatch = useDispatch();
  const { weightDifferenceId: id, ...props } = item;
  const defaultValues = { id, ...props };

  async function onSubmit(payload) {
    return dispatch(weightDifferencesActions.update({ id, payload }));
  }

  return (
    <WeightDifferencesForm
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      isUpdate
    />
  );
}
